import { render } from "./Nominas.vue?vue&type=template&id=901d41d0"
import script from "./Nominas.vue?vue&type=script&lang=js"
export * from "./Nominas.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__